import { useState } from "react";
import { FILE_BASE_URL } from "../services/api";
import "./ViewCustomerModal.css";
import { toDateTimeLocalInputValue } from "../utils/dateTime";

export default function ViewCustomerModal({
  viewData,
  setViewData,
  formatDateFull,
  setPreviewImage,
  deleteCustomer,
  fetchCustomers,
  setForm,
  setEditId,
  setShowModal,
  setFiles
}) {
  const [preview, setPreview] = useState(null);
  if (!viewData) return null;

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-container">

          {/* HEADER */}
          <div className="modal-header">
            <h2>Customer Details</h2>
            <button
              className="close-btn"
              onClick={() => setViewData(null)}
            >
              ✖
            </button>
          </div>

          {/* BODY */}
          <div className="modal-body view-grid">

            {/* DETAILS */}
            <div className="details-card">
              <p><b>Name:</b> {viewData.fullName}</p>
              <p><b>Phone:</b> {viewData.phone}</p>
              <p><b>Car:</b> {viewData.car}</p>
              <p><b>Reg. Number:</b> {viewData.regNo}</p>
              <p><b>Pickup:</b> {formatDateFull(viewData.pickupDate)}</p>
              <p><b>Drop:</b> {formatDateFull(viewData.dropDate)}</p>
              <p style={{ marginTop: 8, paddingTop: 8, borderTop: "1px solid #ddd" }}>
                <b>Duration:</b> {viewData.totalDays?.toFixed(2)} days ({viewData.totalHours?.toFixed(1)} hrs)
              </p>
              <p><b>Per Day Rate:</b> ₹{viewData.perDayRate || viewData.amount}</p>
              <p><b>Total Amount:</b> ₹{viewData.amount}</p>
              
              {/* ADVANCE & PENDING DISPLAY */}
              {(viewData.advanceAmount !== undefined || viewData.pendingAmount !== undefined) && (
                <>
                  <p style={{ marginTop: 12, paddingTop: 12, borderTop: "1px solid #ddd", color: "#22c55e", fontWeight: 600 }}>
                    <b>Advance Amount:</b> ₹{viewData.advanceAmount || 0}
                  </p>
                  <p style={{ color: "#f97316", fontWeight: 600 }}>
                    <b>Pending Amount:</b> ₹{viewData.pendingAmount || viewData.amount}
                  </p>
                </>
              )}
            </div>

            {/* DOCUMENTS */}
            <div>
              <h3 style={{ marginBottom: 10 }}>Documents</h3>

              <div className="images-grid">

                {[
                  { label: "Aadhar Front", key: "aadharFront" },
                  { label: "Aadhar Back", key: "aadharBack" },
                  { label: "Licence", key: "licence" },
                  { label: "Address Proof", key: "addressProof" }
                ].map((doc) => {
                  const path = viewData.documents?.[doc.key];
                  if (!path) return null;

                  const isPDF = path.endsWith(".pdf");
                  const fullUrl = FILE_BASE_URL + "/" + path;

                  return (
                    <div className="img-card" key={doc.key}>

                      {isPDF ? (
                        <a
                          href={fullUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="pdf-link"
                        >
                          📄 View PDF
                        </a>
                      ) : (
                        <img
                          src={fullUrl}
                          alt={doc.label}
                          onClick={() => setPreview(fullUrl)}
                          style={{ cursor: "pointer" }}
                        />
                      )}

                      <span>{doc.label}</span>
                    </div>
                  );
                })}

              </div>
            </div>

          </div>

          {/* FOOTER */}
          <div className="modal-footer">

            {/* EDIT */}
            <button
              className="btn-primary"
              onClick={() => {
                const c = viewData;

                setForm({
                  fullName: c.fullName || "",
                  phone: c.phone || "",
                  car: c.car || "",
                  regNo: c.regNo || "",
                  pickupDate: toDateTimeLocalInputValue(c.pickupDate),
                  dropDate: toDateTimeLocalInputValue(c.dropDate),
                  amount: c.perDayRate || "",
                  advanceAmount: c.advanceAmount || ""
                });

                // Load existing documents for editing
                if (setFiles) {
                  const existingDocs = {};
                  ['aadharFront', 'aadharBack', 'licence', 'addressProof'].forEach(key => {
                    if (c.documents?.[key]) {
                      existingDocs[key] = { isExisting: true, path: c.documents[key] };
                    }
                  });
                  setFiles(existingDocs);
                }

                setEditId(c._id);
                setShowModal(true);
                setViewData(null);
              }}
            >
              Edit
            </button>

            {/* DELETE */}
            <button
              className="btn-danger"
              onClick={async () => {
                if (!window.confirm("Delete this record?")) return;

                await deleteCustomer(viewData._id);
                fetchCustomers();
                setViewData(null);
              }}
            >
              Delete
            </button>

            {/* CLOSE */}
            <button
              className="btn-secondary"
              onClick={() => setViewData(null)}
            >
              Close
            </button>

          </div>

        </div>
      </div>

      {/* 🔥 IMAGE PREVIEW FULL SCREEN */}
      {preview && (
        <div
          className="modal-overlay"
          onClick={() => setPreview(null)}
          style={{ zIndex: 1001, background: "rgba(0,0,0,0.9)" }}
        >
          <img
            src={preview}
            alt="preview"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "10px"
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}